module.exports = __webpack_public_path__ + "img/logo_keolis_en.a297662a.jpg";